import { BaseViewModel } from 'src/app/model/base-model';
import { Signatory } from './signatory';

export class SignatoryDTO {
    id?: number;
    trackId?: any;
    name: string;
    ssn: string;
    mail: string;
    signatureType: number;
    subscriberType: number;
    active: boolean;
    order: number;
    allSegments: boolean;
    segments: Array<BaseViewModel>;
    phoneNumber: string;
    acceptWhatsApp: boolean;
    signatoryTypeRoleId: number;

    constructor(signatory: Signatory) {
        this.id = signatory.id;
        this.trackId = signatory.trackId;
        this.name = signatory.name;
        this.ssn = signatory.ssn;
        this.mail = signatory.mail;
        this.active = signatory.active;
        this.order = signatory.order;
        this.signatureType = signatory.signatureType.id;
        this.subscriberType = signatory.subscriberType.id;
        this.allSegments = signatory.allSegments;
        this.segments = signatory.segments;
        this.phoneNumber = signatory.phoneNumber;
        this.acceptWhatsApp = signatory.acceptWhatsApp;
        this.signatoryTypeRoleId = signatory.signatoryTypeRoleId;
    }
}
